import axios from "@/api/axiosInstance";
import { GetCatalogMetadataResponse } from "./types";

// Filter facets (levels, trades) for the member-facing course catalog. Accepts
// an optional AbortSignal for cancellation parity with getCatalog.
export const getCatalogMetadata = async (
  signal?: AbortSignal,
): Promise<GetCatalogMetadataResponse> => {
  const response = await axios.get<GetCatalogMetadataResponse>(
    "/api/private/learning-center/catalog/metadata",
    { signal },
  );
  return response.data;
};
